import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import Card from "@mui/material/Card";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

function IntegrationsSuccess() {
  const location = useLocation();
  const navigate = useNavigate();

  const [integration, setIntegration] = useState(null);
  const [connected, setConnected] = useState(null);

  useEffect(() => {
    // parse URL params once
    const params = new URLSearchParams(window.location.search);
    const integrationParam = params.get("integration");
    const connectedParam = params.get("connected") === "true";

    setIntegration(integrationParam || "Unknown");
    setConnected(connectedParam);

    console.log("ran", integrationParam, connectedParam);

    // only run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        py={3}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Card sx={{ p: 4, width: "100%", textAlign: "center" }}>
          <SoftBox display="flex" justifyContent="center" mb={2}>
            {connected ? (
              <CheckCircleOutlineRoundedIcon color="success" sx={{ fontSize: 80 }} />
            ) : (
              <ErrorOutlineRoundedIcon color="error" sx={{ fontSize: 80 }} />
            )}
          </SoftBox>

          <SoftTypography variant="h4" fontWeight="bold" gutterBottom>
            {connected
              ? `${integration} connected successfully!`
              : "Connection failed"}
          </SoftTypography>

          <SoftTypography variant="body2" color="text">
            {connected
              ? `Your ${integration} account has been linked. You can now sync your devices and manage integrations.`
              : `Something went wrong connecting ${integration}. Please try again.`}
          </SoftTypography>

          <SoftBox mt={4}>
            <SoftButton
              variant="contained"
              color={connected ? "success" : "error"}
              onClick={() => navigate("/integrations")}
            >
              Back to Integrations
            </SoftButton>
          </SoftBox>
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default IntegrationsSuccess;
